import { render, staticRenderFns } from "./DataCenter.vue?vue&type=template&id=5118e5da&scoped=true&"
import script from "./DataCenter.vue?vue&type=script&lang=js&"
export * from "./DataCenter.vue?vue&type=script&lang=js&"
import style0 from "./DataCenter.vue?vue&type=style&index=0&id=5118e5da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5118e5da",
  null
  
)

export default component.exports